<template>
  <div class="container">
      <form @submit.stop.prevent="saveSettings">
          <div class="form-group">
              <label for="">Username</label>
              <input type="text" v-model="username">
          </div>
          <div class="form-group">
              <label for="">Password</label>
              <input type="password" v-model="password">
          </div>
          <div class="form-group">
              <label for="">API Endpoint</label>
              <input type="text" v-model="apiEndpoint">
          </div>
          <button class="active">Save</button>
      </form>
  </div>
</template>

<script>
import { settings as settingsDb } from '@/database';

export default {
    name: 'Settings',

    data() {
        return {
            username: null,
            password: null,
            apiEndpoint: null,
        }
    },

    methods: {
        buildSettings() {
            settingsDb.getItem('username').then(value => {
                this.username = value
            });
            settingsDb.getItem('password').then(value => {
                this.password = value
            });
            settingsDb.getItem('api-endpoint').then(value => {
                this.apiEndpoint = value
            });
        },

        saveSettings() {
            settingsDb.setItem('username', this.username);
            settingsDb.setItem('password', this.password);
            settingsDb.setItem('api-endpoint', this.apiEndpoint);
            alert('Saved')
        }
    },

    mounted() {
        this.buildSettings();
    }
}
</script>

<style lang="scss" scoped>
form {
    margin: 0 auto;
    padding: 10px;
    max-width: 300px;
    background-color: #ebebeb;
    border: 1px solid #ccc;

    .form-group {
        display: flex;
        flex-direction: column;

        margin: 15px 0 10px 0;

        label {
            margin-bottom: 5px;
            font-weight: 700;
        }

        input {
            padding: 2px 5px;
            height: 38px;
            font-size: 1.8rem;
            border: 1px solid #999;
            border-radius: 2px;
        }
    }

    button {
        width: 100%;
        height: 36px;
        border-radius: 2px;
    }
}

</style>